import axios from "axios";
import { APIURL } from "../Constantes";
import { getCabecera } from "../utils/getCabecera";
import { getError } from "../utils/errors";

const urlCotizacion = "Cotizacion";
export const deleteCotizacion = async ({ idCotizacion }) => {
    return axios.delete(`${APIURL}/${urlCotizacion}/Delete/${idCotizacion}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}
export const updateCotizacion = async ({
    IdCotizacion,
    IdMoneda,
    NombrePaquete,
    Descripcion,
    MontoPaquete,
    NumeroPersona,
    ClavePaquete,
    FechaSalida,
    Internacional,
    IdMonedaProveedor,
    TipoCambioPrevisto,
    lSuplemento,
    Adultos,
    Menores,
    Infantes,
    IdObjetoPaquete,
    lFormatoPago,
}) => {
    return axios.put(`${APIURL}/${urlCotizacion}/Update/${IdCotizacion}`, {
        IdMoneda,
        NombrePaquete,
        Descripcion,
        MontoPaquete,
        NumeroPersona,
        ClavePaquete,
        FechaSalida,
        Internacional,
        IdMonedaProveedor,
        TipoCambioPrevisto,
        lSuplemento,
        Adultos,
        Menores,
        Infantes,
        IdObjetoPaquete,
        lFormatoPago,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}
export const newCotizacion = async ({ IdAgente, IdCliente, IdMoneda, NombrePaquete, Descripcion, MontoPaquete, NumeroPersona, ClavePaquete, FechaSalida, NumeroPagos, Internacional, IdMonedaProveedor, TipoCambioPrevisto, lSuplemento, Adultos, Menores, Infantes, IdObjetoPaquete, lFormatoPago }) => {
    return axios.post(`${APIURL}/${urlCotizacion}/Add`, {
        IdAgente,
        IdCliente,
        IdMoneda,
        NombrePaquete,
        Descripcion,
        MontoPaquete,
        NumeroPersona,
        ClavePaquete,
        FechaSalida,
        NumeroPagos,
        Internacional,
        IdMonedaProveedor,
        TipoCambioPrevisto,
        lSuplemento,
        Adultos,
        Menores,
        Infantes,
        IdObjetoPaquete,
        lFormatoPago
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}
export const getComisionable = async () => {
    return axios.get(`${APIURL}/${urlCotizacion}/Comisionable`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getNoComisionable = async () => {
    return axios.get(`${APIURL}/${urlCotizacion}/NoComisionable`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
//* GET /api/Cotizacion/ObtenerComisiones/{agente}/{Fecha}
export const getComisionesAgente = async ({ agente, fechaFiltro }) => {
    return axios.get(`${APIURL}/${urlCotizacion}/ObtenerComisiones/${agente}/${fechaFiltro}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getComisionesPagadas = async (agente, mes) => {
    return axios.get(`${APIURL}/${urlCotizacion}/ObtenerComisionesPagadas/${agente}/${mes}/`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getMesComisiones = async () => {
    return axios.get(`${APIURL}/${urlCotizacion}/MesComision`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getSueldoBase = async () => {
    return axios.get(`${APIURL}/${urlCotizacion}/SueldoBase`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getTotalVentas = async () => {
    return axios.get(`${APIURL}/${urlCotizacion}/TotalVentas`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getTotalVentasMarcadas = async (agente) => {
    return axios.get(`${APIURL}/${urlCotizacion}/TotalVentasMarcado/${agente}/`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getTotalVentasAgente = async (agente) => {
    return axios.get(`${APIURL}/${urlCotizacion}/TotalVentas/${agente}/`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getCalculoComision = async (total) => {
    return axios.get(`${APIURL}/${urlCotizacion}/CalculoComision/${total}/`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const checkAllComicion = async ({ payload }) => {
    return await axios.post(`${APIURL}/${urlCotizacion}/MarcarTodasComision`, payload, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}
export const checkComicion = async ({ payload }) => {
    return await axios.post(`${APIURL}/${urlCotizacion}/MarcarComision`, payload, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}
export const pagarComicion = async ({ payload }) => {
    return await axios.post(`${APIURL}/${urlCotizacion}/PagarComision`, payload, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}
export const getPaqueteHabitacionPersona = ({ ClavePaquete, NumeroPersonas }) => {
    return axios.get(`${APIURL}/${urlCotizacion}/Hotel/Room/${ClavePaquete}/${NumeroPersonas}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}
export const getPlazosBanco = ({ PrecioPaquete, IdBanco }) => {
    return axios.get(`${APIURL}/${urlCotizacion}/CreditCard/${PrecioPaquete}/${IdBanco}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}
export const getCotizacionPdf = async ({ IdCotizacion }) => {
    return await axios.get(`${APIURL}/${urlCotizacion}/Get/PDF/${IdCotizacion}`,
        {
            headers: getCabecera(),
            responseType: "arraybuffer"
        })
        .then((Response) => {
            return { contentType: Response.headers["content-type"], data: Response.data };
        })
        .catch((Error) => {
            return getError(Error);
        })
}
export const getCotizacion = async ({ idCotizacion }) => {
    return await axios.get(
        `${APIURL}/${urlCotizacion}/Get/${idCotizacion}`, {
        headers: getCabecera(),
    }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return {};
    }))
}
//*Metodo para aceptar una cotizacion
export const putAceptarCotizacion = async ({ IdCotizacion }) => {
    return await axios.put(`${APIURL}/${urlCotizacion}/Accepted/Client/${IdCotizacion}`, {
    }, {
        headers: getCabecera(),
    }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
///* GET /api/Cotizacion/Accepted/Client/{IdCotizacion}/{Pagina}/{Registros}
//*Metodo para aceptar una cotizacion
export const getAllCotizacionesPaginacion = async ({ IdCotizacion, Pagina, Registros }) => {
    return await axios.get(`${APIURL}/${urlCotizacion}/Accepted/Client/${IdCotizacion}/${Pagina}/${Registros}`,
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
///* GET /api/Cotizacion/Accepted/Client/All
//*Metodo para aceptar una cotizacion
export const getAllCotizaciones = async ({ }) => {
    return await axios.get(`${APIURL}/${urlCotizacion}/Accepted/Client/All`,
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
//* PUT /api/Cotizacion/Accepted/Agent/{IdCotizacion}
//*Metodo para aceptar una cotizacion por parte del agente
export const putAceptarCotizacionAgente = async ({ idCotizacion }) => {
    return await axios.put(`${APIURL}/${urlCotizacion}/Accepted/Agent/${idCotizacion}`,
        {

        },
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
//* PUT Cotizacion/Accepted/Supervisor/{IdCotizacion}
//*Metodo para aceptar una cotizacion por parte del agente supervisor del modulo de review
export const putAceptarCotizacionAgenteSupervisor = async ({ idCotizacion }) => {
    return await axios.put(`${APIURL}/${urlCotizacion}/Accepted/Supervisor/${idCotizacion}`,
        {

        },
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
//*PUT /api/Cotizacion/Resend/Contract/{IdCotizacion}
//*Metodo para reenviar una cotizacion por parte del agente
export const putRenviarCotizacionAgente = async ({ idCotizacion }) => {
    return await axios.put(`${APIURL}/${urlCotizacion}/Resend/Contract/${idCotizacion}`,
        {

        },
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
//*PUT /api/Cotizacion/Declined/{IdCotizacion}
//*Metodo para declinar una cotizacion por parte del team leader
export const putDeclinarCotizacionAgente = async ({ idCotizacion }) => {
    return await axios.put(`${APIURL}/${urlCotizacion}/Declined/${idCotizacion}`,
        {
        },
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
//*PUT /api/Cotizacion/Declined/Supervisor/{IdCotizacion}
//*Metodo para declinar una cotizacion por parte de agente supervisor
export const putDeclinarCotizacionAgenteSupervisor = async ({ idCotizacion }) => {
    return await axios.put(`${APIURL}/${urlCotizacion}/Declined/Supervisor/${idCotizacion}`,
        {
        },
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
//* PUT /api/Cotizacion/Declined/Agent/{IdCotizacion}
//*Metodo para declinar una cotizacion por parte del team leader y regresarla editar
export const putDeclinarCotizacionAgenteEdit = async ({ idCotizacion }) => {
    return await axios.put(`${APIURL}/${urlCotizacion}/Declined/Agent/${idCotizacion}`,
        {
        },
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
//* PUT /api/Cotizacion/Finish/{IdCotizacion}
//* Metodo para completar una cotizacion en caso de falla
export const putCompletarCotizacionProceso = async ({ idCotizacion }) => {
    return await axios.put(`${APIURL}/${urlCotizacion}/Finish/${idCotizacion}`,
        {
        },
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
//* Calculo de pagos para hibrido siendo CIE
//* GET /api/Cotizacion/MonthlyPayments/Number/Hibrid/{FechaSalida}
export const getMensualidadHibridoCalculo = async ({ fechaSalida }) => {
    return await axios.get(`${APIURL}/${urlCotizacion}/MonthlyPayments/Number/Hibrid/${fechaSalida}`,
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        // return getError(Error);
        return 0
    }))
}
//* Calculo de pagos para la cotizacion hibrido
//* GET /api/Cotizacion/Hibrid/{PrecioPaquete}/{FecSalida}/{IdBanco}/{PorCIE}/{PorTC}/{NumPagoCIE}
export const getCalculoHibridoPagos = async ({ PrecioPaquete, FecSalida, IdBanco, PorCIE, PorTC, NumPagoCIE }) => {
    return await axios.get(`${APIURL}/${urlCotizacion}/Hibrid/${PrecioPaquete}/${FecSalida}/${IdBanco}/${PorCIE}/${PorTC}/${NumPagoCIE}`,
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        // return getError(Error);
        return []
    }))
}
//* Actulizar la vigencia de la cotizacion
//* PUT /api/Cotizacion/Renew/ExpirationDate/{IdCotizacion}/{FechaExpiracion}
export const putActulizarVigenciaCotizacion = async ({ idCotizacion, FechaExpiracion }) => {
    return await axios.put(`${APIURL}/${urlCotizacion}/Renew/ExpirationDate/${idCotizacion}/${FechaExpiracion}`,
        {
        },
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return getError(Error);
    }))
}
//* Obtener Reporte de cotizaciones agente por dia
//* GET Cotizacion/Report/Agent/Day/{IdAgente}/{Fecha}
//todo: Formarto de fecha MMddyyyy
//todo: el idAgente es el AspNet
export const getReporteCotizacionesAgenteDia = async ({ IdAgente, Fecha }) => {
    return await axios.get(`${APIURL}/${urlCotizacion}/Report/Agent/Day/${IdAgente}/${Fecha}`,
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        // return getError(Error);
        return []
    }))
}
//* Obtener Reporte de cotizaciones agente por mes
//* GET Cotizaicon/Report/Agent/Month/{IdAgente}/{Fecha}
//todo: Formarto de fecha MMyyyy
//todo: el idAgente es el AspNet
export const getReporteCotizacionesAgenteMes = async ({ IdAgente, Fecha }) => {
    return await axios.get(`${APIURL}/${urlCotizacion}/Report/Agent/Month/${IdAgente}/${Fecha}`,
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        // return getError(Error);
        return []
    }))
}
//* Obtener todas las cotizaciones por dia
//* GET Cotizacion/Report/All/Day/{Fecha}
//todo: Formarto de fecha MMddyyyy
export const getReporteCotizacionesAllDia = async ({ Fecha }) => {
    return await axios.get(`${APIURL}/${urlCotizacion}/Report/All/Day/${Fecha}`,
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        // return getError(Error);
        return []
    }))
}
//* Obtener todas las cotizaciones por mes
//* GET Cotizacion/Report/All/Month/{Fecha}
//todo: Formato de fecha MMyyyy
export const getReporteCotizacionesAllMes = async ({ Fecha }) => {
    return await axios.get(`${APIURL}/${urlCotizacion}/Report/All/Month/${Fecha}`,
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        // return getError(Error);
        return []
    }))
}

//* Obtener todas las cotizaciones que necesitan autorizacion de doble cotizacion
//* GET Cotizacion/Pending/Review
export const getCotizacionesRevisionAdminAll = async () => {
    return await axios.get(`${APIURL}/${urlCotizacion}/Pending/Review`,
        {
            headers: getCabecera(),
        }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        // return getError(Error);
        return []
    }))
}